// extracted by mini-css-extract-plugin
export var searchHeader = "_70-0";
export var searchHeaderDark = "_70-1";